module.exports = __webpack_public_path__ + "img/widget-coupon-mockup.396a832c.svg";